import axiosRequest from '../index'
import api from '../api'
import config from '../config'

const { env } = config
const needMock = true && env === 'LOCAL'

const mockData = ISDEVELOPMENT ? require('../mockData') : ''

// 获取汇率
export function getTerms (mmaclientid, policyno, type, detail = '') {
  const url = api.terms
    .replace('{mmaclientid}', mmaclientid)
    .replace('{policyno}', policyno)
    .replace('{type}', type)
    .replace('{detail}', detail)
  if (needMock) {
    return Promise.resolve(mockData.terms.data)
  }
  return axiosRequest(url)
}
// 获取保单支持的支付方式
export function getPaymentMethod (mmaclientid, policyno, type = 1) {
  const url = api.paymentMethod
    .replace('{mmaclientid}', mmaclientid)
    .replace('{policyno}', policyno)
    .replace('{type}', type)
  return axiosRequest(url)
}

// 产品详情
export function getProductDetail (productCode, region, lang) {
  const url = api.productDetail
    .replace('{productCode}', productCode)
    .replace('{region}', region)
    .replace('{lang}', lang)
  // console.log('url', url)
  if (needMock) {
    return Promise.resolve(mockData.productDetail.data)
  }
  return axiosRequest(url)
}

// 保单列表
export function getPolicyList (mmaclientid, category, type = '', start, count) {
  const url = api.policyList.replace('{mmaclientid}', mmaclientid)
    .replace('{type}', type)
    .replace('{category}', category)
    .replace('{start}', start)
    .replace('{count}', count)
  if (needMock) {
    return Promise.resolve(mockData.policyList.data)
  }
  return axiosRequest(url, {
    needEncrypt: false,
    needXsign: false
  })
}

// 保单详情
export function getPolicyDetail (mmaclientid, body, type = 1) {
  const url = api.policyDetail.replace('{mmaclientid}', mmaclientid).replace('{type}', type)
  if (needMock) {
    return Promise.resolve(mockData.policyDetail.data)
  }
  return axiosRequest(url, {
    method: 'POST',
    data: body,
    needEncrypt: true,
    needXsign: true
  })
}

// 申请列表
export function getApplicationList (mmaclientid, category, start, count) {
  const url = api.applicationList.replace('{mmaclientid}', mmaclientid)
    .replace('{category}', category)
    .replace('{start}', start)
    .replace('{count}', count)
  if (needMock) {
    return Promise.resolve(mockData.applicationDetail.data)
  }
  return axiosRequest(url, {
    needEncrypt: false,
    needXsign: false
  })
}

// 申请列表（准客户）
export function getApplicationListForProUser (uin, start, count) {
  const url = api.getApplicationListForProUser.replace('{uin}', uin)
    .replace('{start}', start)
    .replace('{count}', count)
  if (needMock) {
    return Promise.resolve(mockData.getPaymentServiceList[6].data)
  }
  return axiosRequest(url, {
    method: 'GET',
    needEncrypt: false,
    needXsign: false
  })
}

// 申请详情
export function getApplicationDetail (mmaclientid, body) {
  const url = api.applicationDetail.replace('{mmaclientid}', mmaclientid)
  if (needMock) {
    return Promise.resolve(mockData.applicationDetail.data)
  }
  return axiosRequest(url, {
    method: 'POST',
    data: body,
    needEncrypt: false,
    needXsign: false
  })
}
// 申请详情（准客户）
export function getApplicationDetailForProUser (uin, policyid) {
  const url = api.getApplicationDetailForProUser.replace('{uin}', uin)
    .replace('{policyid}', policyid)
  if (needMock) {
    return Promise.resolve(mockData.applicationDetailForProUser.data)
  }
  return axiosRequest(url, {
    method: 'GET',
    needEncrypt: false,
    needXsign: false
  })
}

// 榜单详情
export function getHotList (bannerId, region) {
  const url = api.hotlistDetail.replace('{bannerId}', bannerId).replace('{region}', region)
  // console.log('url', url)
  if (needMock) {
    return Promise.resolve(mockData.hotList.data)
  }
  return axiosRequest(url)
}

// 消息详情
export function getNewsDetail (msgId) {
  const url = api.newsDetail.replace('{msgId}', msgId)
  if (needMock) {
    return Promise.resolve(mockData.newsDetail.data)
  }
  return axiosRequest(url)
}

/**
 * @func 顾问服务列表
 * @param {String} category 服务类型跟随 '@/config/paymentCategory.js'
 */
export function getPaymentServiceList (mmaclientid, category, start, count) {
  const url = api.paymentServiceList
    .replace('{mmaclientid}', mmaclientid)
    .replace('{type}', category)
    .replace('{start}', start)
    .replace('{count}', count)
  if (needMock) {
    return Promise.resolve(mockData.getPaymentServiceList[category].data)
  }
  return axiosRequest(url)
}
